import { useSidebarCollapseContext } from '@/context/SidebarCollapseContext.tsx';
import { getSidebarWidthPx } from '@/hooks/ui/sidebarConstants.ts';
import { useIsMobileViewport } from '@/hooks/ui/useIsMobileViewport.ts';

// The composer dock and anything that must align with it (e.g. the jump-to-bottom button) center on
// the inset content card the page scrolls inside (see _authenticated.tsx), NOT the raw viewport. The
// card sits at the sidebar's right edge behind a 1px border, with an 8px right margin and a 6px
// reserved scrollbar gutter. A viewport-anchored, fixed element subtracts those itself.
// CARD_RIGHT_MARGIN_PX = card mr={md:2}; CARD_BORDER_PX = its 1px border; SCROLLBAR_GUTTER_PX =
// index.css ::-webkit-scrollbar width + scrollbar-gutter: stable; EDGE_NUDGE_PX = a fine shift applied
// to both edges (so width is preserved) for sub-pixel rounding.
const CARD_RIGHT_MARGIN_PX = 8;
const CARD_BORDER_PX = 1;
export const SCROLLBAR_GUTTER_PX = 6;
const EDGE_NUDGE_PX = 2;
export const DOCK_RIGHT_OFFSET = `calc(${CARD_RIGHT_MARGIN_PX}px + ${CARD_BORDER_PX}px + ${SCROLLBAR_GUTTER_PX}px + ${EDGE_NUDGE_PX}px)`;

/**
 * The fixed-position left/right insets that define the content axis the composer centers on. Shared
 * so the dock and the jump-to-bottom button stay locked to the same axis instead of silently drifting
 * apart when the shell chrome changes.
 */
export const useComposerDockAxis = () => {
	const { isCollapsed, hasSidebar } = useSidebarCollapseContext();
	const isMobile = useIsMobileViewport();
	const sidebarWidth = !isMobile && hasSidebar ? getSidebarWidthPx(isCollapsed) : '0px';

	const left = isMobile || !hasSidebar ? '0px' : `calc(${sidebarWidth} + ${CARD_BORDER_PX}px - ${EDGE_NUDGE_PX}px)`;
	const rightOfContent = isMobile ? '0px' : !hasSidebar ? `${SCROLLBAR_GUTTER_PX}px` : DOCK_RIGHT_OFFSET;
	const right = rightOfContent;

	return { left, right, isMobile, sidebarWidth };
};
